module.exports = __webpack_public_path__ + "static/media/whatwedo.00fe244d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/whatwedo.jpg
// module id = 95
// module chunks = 0